/** @format */

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
	ChildTypography,
	CopyRightDiv,
	CopyRightTypography,
	FooterChildContainer,
	FooterContainer,
	SubHeaderDiv,
	TextAreaTypography,
} from "./styles";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Link, MenuItem, Select, Typography } from "@mui/material";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from '@mui/icons-material/Facebook';
import { AppDispatch } from "../../redux/store/store";
import { setLanguage } from "../../redux/slices/languageSlice";
import { selectCurrentLanguage } from "../../redux/selectors/languageSelector";
import i18n from "../../config/i18n";

const Footer = ({ variant = "circle" }: { variant?: "circle" | "recover" }) => {
	const dispatch = useDispatch<AppDispatch>();
	const currentLanguage = useSelector(selectCurrentLanguage);
	const { t } = useTranslation("footer");

	const handleLanguageChange = (newLanguage: "en" | "es" | "fr" | "mx") => {
		dispatch(setLanguage(newLanguage));
		i18n.changeLanguage(newLanguage);
	};

	return (
		<FooterContainer>
			{variant === "recover" ? (
				<>
					{/* Quick Links (Recover) */}
					<FooterChildContainer>
						<SubHeaderDiv>
							<ChildTypography>{t("quickLinks")}</ChildTypography>
							<Link href="/business" underline="none" sx={{ color: "#fff" }}>
								{t("home")}
							</Link>
							<Link href="/business#features" underline="none" sx={{ color: "#fff" }}>
								{t("features")}
							</Link>
							<Link href="/business#integrations" underline="none" sx={{ color: "#fff" }}>
								{t("recover.integrations")}
							</Link>
							<Link href="/business/pricing" underline="none" sx={{ color: "#fff" }}>
								{t("recover.pricing")}
							</Link>
						</SubHeaderDiv>
					</FooterChildContainer>

					{/* Product (Recover) */}
					<FooterChildContainer>
						<SubHeaderDiv>
							<ChildTypography>{t("recover.product")}</ChildTypography>
							<Link href="/business#features" underline="none" sx={{ color: "#fff" }}>
								{t("recover.overdueRecovery")}
							</Link>
							<Link href="/business#integrations" underline="none" sx={{ color: "#fff" }}>
								{t("recover.quickbooksSync")}
							</Link>
							<Link href="/business#tour" underline="none" sx={{ color: "#fff" }}>
								{t("recover.paymentReliability")}
							</Link>
							<Link href="/collect/sign-up" underline="none" sx={{ color: "#fff" }}>
								{t("recover.startFree")}
							</Link>
							<Link href="/collect/sign-in" underline="none" sx={{ color: "#fff" }}>
								{t("recover.signIn")}
							</Link>
						</SubHeaderDiv>
					</FooterChildContainer>
				</>
			) : (
				<>
					{/* Quick Links */}
					<FooterChildContainer>
						<SubHeaderDiv>
							<ChildTypography>{t("quickLinks")}</ChildTypography>
							<Link href="/" underline="none" sx={{ color: "#fff" }}>
								{t("home")}
							</Link>
							<Link href="/features" underline="none" sx={{ color: "#fff" }}>
								{t("features")}
							</Link>
							<Link href="/about-us" underline="none" sx={{ color: "#fff" }}>
								{t("aboutUs")}
							</Link>
							<Link href="/fees" underline="none" sx={{ color: "#fff" }}>
								{t("fees")}
							</Link>
							<Link href="/faq" underline="none" sx={{ color: "#fff" }}>
								{t("faq")}
							</Link>
							<Link href="/supported-countries" underline="none" sx={{ color: "#fff" }}>
								{t("supportedCountries")}
							</Link>
							{/* <Link href="/feedback" underline="none" sx={{ color: "#fff" }}>
						Share Feedback
					</Link> */}
						</SubHeaderDiv>
					</FooterChildContainer>

					{/* Products */}
					<FooterChildContainer>
						<SubHeaderDiv>
							<ChildTypography>{t("ourProducts")}</ChildTypography>
							<Link
								href="/products/savings-circles"
								underline="none"
								sx={{ color: "#fff" }}>
								{t("savingsCircles")}
							</Link>
							<Link
								href="/products/group-contributions"
								underline="none"
								sx={{ color: "#fff" }}>
								{t("groupContributions")}
							</Link>
							<Link
								href="/products/financial-planning"
								underline="none"
								sx={{ color: "#fff" }}>
								{t("financialPlanning")}
							</Link>
							<Link
								href="/products/secure-payments"
								underline="none"
								sx={{ color: "#fff" }}>
								{t("securePayments")}
							</Link>
							<Link
								href="/products/community-support"
								underline="none"
								sx={{ color: "#fff" }}>
								{t("communitySupprt")}
							</Link>
						</SubHeaderDiv>
					</FooterChildContainer>
				</>
			)}

			{/* Existing Location */}
			<FooterChildContainer>
				<SubHeaderDiv>
					<ChildTypography>{t("location")}</ChildTypography>
					<TextAreaTypography>{t("houston")}</TextAreaTypography>
				</SubHeaderDiv>
			</FooterChildContainer>

			{/* Existing Contact */}
			<FooterChildContainer>
				<SubHeaderDiv>
					<ChildTypography>{t("contact")}</ChildTypography>
					<TextAreaTypography>{t("email")}</TextAreaTypography>
					<TextAreaTypography></TextAreaTypography>
				</SubHeaderDiv>
			</FooterChildContainer>

			{/* Socials & Downloads */}
			<FooterChildContainer>
				<SubHeaderDiv>
					<ChildTypography>{t("connect")}</ChildTypography>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							gap: 8,
							marginTop: 10,
						}}>
						{/* <Link
              href="#"
              color="inherit"
              underline="none"
              sx={{ color: "#fff" }}
            >
              <AppleIcon fontSize="large" />
            </Link>
            <Link
              href="#"
              color="inherit"
              underline="none"
              sx={{ color: "#fff" }}
            >
              <AndroidIcon fontSize="large" />
            </Link> */}
					</div>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							gap: 12,
							marginTop: 16,
						}}>
						<Link
							href="https://www.linkedin.com/company/106477393/"
							color="inherit"
							underline="none"
							sx={{ color: "#fff" }}>
							<LinkedInIcon />
						</Link>
						{/* <Link
							href="https://twitter.com"
							color="inherit"
							underline="none"
							sx={{ color: "#fff" }}>
							<TwitterIcon />
						</Link> */}
						<Link
							href="https://www.facebook.com/profile.php?id=61566723160780"
							color="inherit"
							underline="none"
							sx={{ color: "#fff" }}>
							<FacebookIcon />
						</Link>
						<Link
							href="https://instagram.com/fundsyfi"
							color="inherit"
							underline="none"
							sx={{ color: "#fff" }}>
							<InstagramIcon />
						</Link>
					</div>
				</SubHeaderDiv>
			</FooterChildContainer>

			{/* Legal & Policies */}
			<FooterChildContainer>
				<SubHeaderDiv>
					<ChildTypography>{t("legalPolicies")}</ChildTypography>
					<Link
						href="/terms-of-service"
						underline="none"
						sx={{ color: "#fff" }}>
						{t("termsOfService")}
					</Link>
					<Link href="/privacy-policy" underline="none" sx={{ color: "#fff" }}>
						{t("privacyPolicy")}
					</Link>
					<Link href="/cookies" underline="none" sx={{ color: "#fff" }}>
						{t("cookiePolicy")}
					</Link>
					<Link href="/disclosure" underline="none" sx={{ color: "#fff" }}>
						{t("disclosure")}
					</Link>
					<Typography variant="body2" sx={{ mt: 2, color: "#fff" }}>
						{t("language")}
					</Typography>
					<Select
						value={currentLanguage}
						onChange={(e) => handleLanguageChange(e.target.value as "en" | "es" | "fr" | "mx")}
						size="small"
						sx={{ background: "#fff", borderRadius: 1, mt: 1 }}>
						<MenuItem value="en">{t("english")}</MenuItem>
						<MenuItem value="es">{t("spanish")}</MenuItem>
						<MenuItem value="fr">{t("french")}</MenuItem>
						<MenuItem value="mx">{t("mexican")}</MenuItem>
					</Select>
				</SubHeaderDiv>
			</FooterChildContainer>

			{/* Copyright */}
			<CopyRightDiv>
				<CopyRightTypography>
					{t("copyright", { year: new Date().getFullYear() })}
				</CopyRightTypography>
			</CopyRightDiv>
		</FooterContainer>
	);
};

export default Footer;
